// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"ScrollLoading_loadingIcon__s6apG","loading":"ScrollLoading_loading__NfU4l","spin":"ScrollLoading_spin__w7XF2","hidden":"ScrollLoading_hidden__uxiJo"};